<template>
    <div>
        <van-cell-group>
            <van-field v-model="handlingId" clearable label="办件编号" placeholder="请输入办件编号"/>
            <verification-code-input @setVerificationCode="getVerificationCode"
                                     ref="childFunction"></verification-code-input>
        </van-cell-group>
        <div class="btn-submit-div">
            <van-button type="info" size="large" @click="query">查询</van-button>
        </div>
    </div>
</template>

<script>
    /**
     * Description: 我的办件进度查询
     * Author: Wangyan
     * Date: 2019-03-25
     * Time: 16:41
     */
    import {CellGroup, Field, Toast, Button} from 'vant'
    import VerificationCodeInput from "@/components/verification-code-input/VerificationCodeInput";
    import { taskApiMap } from "@/api/task";

    export default {
        name: "MyHandlingScheduleQuery",
        components: {
            VerificationCodeInput,
            [CellGroup.name]: CellGroup,
            [Field.name]: Field,
            [Toast.name]: Toast,
            [Button.name]: Button
        },
        data() {
            return {
                handlingId: '', // 办件编号
                receiveVerificationCode: {} // 接收验证码子组件传来verificationInfo对象
            }
        },
        methods: {
            /**
             * 接收验证码输入框组件传来的verificationInfo对象
             * @param value 验证码输入框verificationInfo对象
             */
            getVerificationCode(value) {
                this.receiveVerificationCode = value
            },

            /**
             * 点击查询
             */
            async query() {
                if (!this.handlingId) {
                    Toast('请输入办件编号')
                } else if (!this.receiveVerificationCode.verificationIsNoneStatus) {
                    Toast('请输入验证码')
                } else if (!this.receiveVerificationCode.verificationSuccessStatus) {
                    Toast('请输入正确的验证码')
                } else {
                    Toast.loading({
                        duration: 0,       // 持续展示 toast
                        forbidClick: true, // 禁用背景点击
                        loadingType: 'spinner',
                        message: '查询中...'
                    })
                    try {
                        const data = {
                            genGuid: this.receiveVerificationCode.verificationCodeGuid,
                            validCode: this.receiveVerificationCode.verificationCode
                        }
                        const res = await this.$httpUtils.getCommonUtils(`${taskApiMap.tskNum}/${this.handlingId}`,data)
                        if (res.data.data) {
                            Toast.clear()
                            this.$router.push({
                                path: '/myHandlingScheduleQueryDetails',
                                query: {data: JSON.stringify(res.data.data)}
                            })
                        } else {
                            Toast.fail('查询失败')
                            this.$refs.childFunction.interactionVerificationCode()
                        }
                    } catch (error) {
                        Toast.fail('服务器运行失败，请稍后再试。')
                        console.log(error)
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>
